export { default } from './RoundedRectangleEmpty'
